import { AssignmentListItem } from 'app/models/assignment-list-params'
import * as types from './types'

/**
 * The read's rows, with the generation the request started under: the
 * reducer drops them if a write has bumped it since (utils/generation.ts).
 */
export const getAssignmentList = (rows: AssignmentListItem[], generation?: number) => ({
  type: types.GET_ASSIGNMENT_LIST,
  payload: { rows, generation },
})

/**
 * A write happened that the rows cannot be patched for (a saved draft is not
 * a grid row: its names are resolved by the read). The grid reloads once.
 */
export const invalidateAssignmentList = () => ({
  type: types.INVALIDATE_ASSIGNMENT_LIST,
})

/**
 * The read failed. Clears `stale` so nothing retries forever on a persistent
 * failure; the thunk tells the user, and the next mount reloads.
 */
export const assignmentListLoadFailed = () => ({
  type: types.ASSIGNMENT_LIST_LOAD_FAILED,
})

export const startLoadingAssignmentList = () => ({
  type: types.START_LOADING_ASSIGNMENT_LIST,
})

export const stopLoadingAssignmentList = () => ({
  type: types.STOP_LOADING_ASSIGNMENT_LIST,
})
